import { render, staticRenderFns } from "./AutomationMenu.vue?vue&type=template&id=bc94c47c"
import script from "./AutomationMenu.vue?vue&type=script&lang=js"
export * from "./AutomationMenu.vue?vue&type=script&lang=js"
import style0 from "./AutomationMenu.vue?vue&type=style&index=0&id=bc94c47c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports